import { TenantPackageAddOnGeneric } from '~/tenants/common/package';
import React from 'react';
import { PersonaType } from '~/tenants/common/TenantPersona';
import ZodFieldSelect from '~/components/zod/ZodFieldSelect';
import { format_money } from '~/components/Money';
import TwtNucleusJob from '~/tenants/twt/performable/nucleus/TwtNucleusJob';
import { useZodFormFieldSingleValue } from '~/components/zod/ZodForm';

export default function TwtNucleusAddOns({ persona }: { persona: PersonaType }) {
  const guided = Number(useZodFormFieldSingleValue('guided') ?? 0);
  const hotspots = Number(useZodFormFieldSingleValue('hotspots') ?? 0);

  return (
    <>
      {/*{guided > 0 && (*/}
      {/*  <TenantPackageAddOnGeneric*/}
      {/*    title="Live Virtual Tours"*/}
      {/*    image="tenant/twt/nucleus/live_guided.png"*/}
      {/*    persona={persona}*/}
      {/*    description="Host real-time guided showings where you can walk clients through the property remotely and answer questions live."*/}
      {/*  >*/}
      {/*    <ZodFieldSelect*/}
      {/*      options={[*/}
      {/*        { label: 'No Live Virtual Tours', value: '0' },*/}
      {/*        {*/}
      {/*          label: `25 Live Virtual Tours: ${format_money(TwtNucleusJob.guided(25))}`,*/}
      {/*          value: '25',*/}
      {/*        },*/}
      {/*        {*/}
      {/*          label: `50 Live Virtual Tours: ${format_money(TwtNucleusJob.guided(50))}`,*/}
      {/*          value: '50',*/}
      {/*        },*/}
      {/*        {*/}
      {/*          label: `100 Live Virtual Tours: ${format_money(TwtNucleusJob.guided(100))}`,*/}
      {/*          value: '100',*/}
      {/*        }*/}
      {/*      ]}*/}
      {/*      name="guided"*/}
      {/*    />*/}
      {/*  </TenantPackageAddOnGeneric>*/}
      {/*)}*/}
      {/*{hotspots > 0 && (*/}
      {/*  <TenantPackageAddOnGeneric*/}
      {/*    title="Hotspots"*/}
      {/*    image="tenant/twt/nucleus/hotspot.jpg"*/}
      {/*    persona={persona}*/}
      {/*    description="Let viewers interact with the space, explore product details, or access extra context directly inside the 3D tour."*/}
      {/*  >*/}
      {/*    <ZodFieldSelect*/}
      {/*      options={[*/}
      {/*        { label: 'No Hot Spots', value: '0' },*/}
      {/*        {*/}
      {/*          label: `20 Hot Spots: ${format_money(TwtNucleusJob.hotspots(20))}`,*/}
      {/*          value: '20',*/}
      {/*        },*/}
      {/*        {*/}
      {/*          label: `40 Hot Spots: ${format_money(TwtNucleusJob.hotspots(40))}`,*/}
      {/*          value: '40',*/}
      {/*        },*/}
      {/*        {*/}
      {/*          label: `100 Hot Spots: ${format_money(TwtNucleusJob.hotspots(100))}`,*/}
      {/*          value: '100',*/}
      {/*        },*/}
      {/*        {*/}
      {/*          label: `500 Hot Spots: ${format_money(TwtNucleusJob.hotspots(500))} `,*/}
      {/*          value: '500',*/}
      {/*        }*/}
      {/*      ]}*/}
      {/*      name="hotspots"*/}
      {/*    />*/}
      {/*  </TenantPackageAddOnGeneric>*/}
      {/*)}*/}
      {/*<TenantPackageAddOnInput*/}
      {/*  name="videos"*/}
      {/*  title="AI Enhanced Videos"*/}
      {/*  description="A ready-to-share, high-quality flythrough video auto-generated from your 3D scan - helping you market listings faster, stand out on MLS, Zillow and other listing platforms."*/}
      {/*  label="Videos"*/}
      {/*  image="tenant/twt/nucleus/videos.png"*/}
      {/*  persona={persona}*/}
      {/*  cost={175}*/}
      {/*  costSuffix="/each"*/}
      {/*  inputType="number"*/}
      {/*/>*/}
    </>
  );
}
